import { Table } from 'ui/table/Table';

import { PositionTableRowProps } from './PositionsTableRow.types';

export const PositionsTableRow = ({ position }: PositionTableRowProps) => {
  return <Table.RowItem>{position.nazwa}</Table.RowItem>;
};
